// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.random-page {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #013020;  /* Changed to your dark green color */
    padding: 20px;
}

.random-container {
    background: white;
    border-radius: 15px;
    padding: 30px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
    max-width: 600px;
    width: 100%;
}

.random-container h1 {
    color: black;  /* Changed to your yellow color */
    margin-bottom: 30px;
}

/* Rest of the CSS remains the same */
.loading-animation {
    padding: 40px;
}

.dice-animation {
    font-size: 48px;
    animation: roll 1s infinite;
    margin-bottom: 20px;
}

@keyframes roll {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.result-container {
    padding: 20px;
}

.result-type {
    font-size: 1.2em;
    color: #666;
    margin-bottom: 15px;
}

.result-content {
    margin: 20px 0;
}

.result-content h2 {
    color: #2c3e50;
    margin-bottom: 10px;
}

.result-content p {
    color: #666;
    font-size: 1.1em;
}

.redirect-message {
    color: #888;
    font-style: italic;
    margin: 15px 0;
}

.try-again-button {
    background-color: #4CAF50;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 25px;
    cursor: pointer;
    font-size: 1.1em;
    transition: background-color 0.3s;
    margin-top: 20px;
}

.try-again-button:hover {
    background-color: #45a049;
}

.error-container {
    padding: 20px;
}

.error-message {
    color: #d32f2f;
    margin-bottom: 20px;
}

@media (max-width: 600px) {
    .random-container {
        padding: 20px;
        margin: 10px;
    }

    .result-content h2 {
        font-size: 1.5em;
    }
}`, "",{"version":3,"sources":["webpack://./src/RandomPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB,GAAG,qCAAqC;IACjE,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY,GAAG,iCAAiC;IAChD,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".random-page {\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #013020;  /* Changed to your dark green color */\n    padding: 20px;\n}\n\n.random-container {\n    background: white;\n    border-radius: 15px;\n    padding: 30px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    max-width: 600px;\n    width: 100%;\n}\n\n.random-container h1 {\n    color: black;  /* Changed to your yellow color */\n    margin-bottom: 30px;\n}\n\n/* Rest of the CSS remains the same */\n.loading-animation {\n    padding: 40px;\n}\n\n.dice-animation {\n    font-size: 48px;\n    animation: roll 1s infinite;\n    margin-bottom: 20px;\n}\n\n@keyframes roll {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.result-container {\n    padding: 20px;\n}\n\n.result-type {\n    font-size: 1.2em;\n    color: #666;\n    margin-bottom: 15px;\n}\n\n.result-content {\n    margin: 20px 0;\n}\n\n.result-content h2 {\n    color: #2c3e50;\n    margin-bottom: 10px;\n}\n\n.result-content p {\n    color: #666;\n    font-size: 1.1em;\n}\n\n.redirect-message {\n    color: #888;\n    font-style: italic;\n    margin: 15px 0;\n}\n\n.try-again-button {\n    background-color: #4CAF50;\n    color: white;\n    border: none;\n    padding: 12px 24px;\n    border-radius: 25px;\n    cursor: pointer;\n    font-size: 1.1em;\n    transition: background-color 0.3s;\n    margin-top: 20px;\n}\n\n.try-again-button:hover {\n    background-color: #45a049;\n}\n\n.error-container {\n    padding: 20px;\n}\n\n.error-message {\n    color: #d32f2f;\n    margin-bottom: 20px;\n}\n\n@media (max-width: 600px) {\n    .random-container {\n        padding: 20px;\n        margin: 10px;\n    }\n\n    .result-content h2 {\n        font-size: 1.5em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
